<template>
  <nav class="navbar">
    <ul>
      <li v-for="category in categories" :key="category.id">
        <router-link :to="`/category/${category.id}`">{{ category.name }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script setup>
const categories = [
  { id: 1, name: '技术' },
  { id: 2, name: '生活' },
  { id: 3, name: '旅行' },
];
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  background-color: #f8f9fa;
  padding: 1rem;
}

.navbar ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.navbar li {
  margin: 0 1rem;
}

.navbar a {
  text-decoration: none;
  color: #333;
}

@media (max-width: 768px) {
  .navbar ul {
    flex-direction: column;
    align-items: center;
  }

  .navbar li {
    margin: 0.5rem 0;
  }
}
</style>